import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import MakeScene from '../scenes/MakeScene';
import MainMenu from './MainMenu';
import SubMenu from './SubMenu';
import ZipperTop from './ZipperTop';

export default class MenuController extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {MakeScene} delegate
     * @param {Phaser.GameObjects.Image} dropCollisionSprite
     */
    constructor(delegate, dropCollisionSprite)
    {
        super(delegate);

        this.delegate = delegate;
        this.dropCollisionSprite = dropCollisionSprite;

        this.zipTime = 440;

        this.mainMenu = new MainMenu(this.scene, this);
        this.mainMenu.y = this.scene.scale.height - this.mainMenu.getBounds().height;
        this.add(this.mainMenu);

        this.submenu = new SubMenu(this.scene, this, this);
        this.submenu.y = this.mainMenu.y - this.submenu.workingHeight;
        this.add(this.submenu);

        this.currentMenuIndex = gameData.menuNameIndex.indexOf("backpack");
        let menuInfo = gameData.menu[this.currentMenuIndex];
        this.submenu.setMenu(menuInfo);
        this.keychains = [];

        this.zipperCover = new ZipperTop(this.scene, this.submenu.x, this.submenu.y);
        this.add(this.zipperCover);

        this.activeSubmenu = this.submenu;
    }

    addKeychain(item)
    {
        this.keychains.push(item);
    }

    checkNewItemHit(sprite)
    {
        let didStick = this.delegate.checkNewItemDropHit(sprite);
        return didStick;
    }

    handleKeychainDrop(sprite)
    {
        let index = this.keychains.indexOf(sprite);
        this.keychains.splice(index, 1);
        let didStick = this.delegate.checkNewKeychainDropHit(sprite);
        return didStick;
    }

    handleItemDrop(sprite)
    {
        let didStick = this.delegate.checkNewItemDropHit(sprite);
        return didStick;
    }

    handleItemClick(type, itemIndex)
    {
        if (type == "BACKPACK")
        {
            this.delegate.switchBackgroundItem(itemIndex);
        }
        else if (type == "PATTERNS_button")
        {
            this.delegate.setPatternType(itemIndex);
        }
        else
        {
            // console.log("other click");
        }
    }

    handleMenuClick(menuIndex)
    {
        this.zipTimeDelayedCall?.remove();

        this.zipperCover.close();
        this.zipTimeDelayedCall = this.scene.time.delayedCall(this.zipTime, () =>
        {
            this.zipTimeDelayedCall = null;
            this.currentMenuIndex = menuIndex;
            let menuInfo = gameData.menu[menuIndex];
            switch (menuInfo.type)
            {
                case "click":
                    this.activeSubmenu.setMenu(menuInfo);
                    break;

                case "color":
                    this.activeSubmenu.setCustomColorMenu(menuInfo);
                    break;

                case "dragdrop":
                    this.activeSubmenu.setMenu(menuInfo);
                    break;
            }
            this.zipperCover.open();
        });
    }

    setColorFillType(value)
    {
        this.delegate.setColorFillType(value);
    }

    colorBackpack(color)
    {
        this.delegate.colorBackpack(color);
    }

    preUpdate(time, dt)
    {
        let len = this.keychains.length;
        for (var i = 0; i < len; i++)
        {
            this.keychains[i].tick(dt/1000);
        }
    }
}